import { render, staticRenderFns } from "./NextArrowIconNeutral.vue?vue&type=template&id=33d73c07&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('33d73c07', component.options)
    } else {
      api.rerender('33d73c07', component.options)
    }
    module.hot.accept("./NextArrowIconNeutral.vue?vue&type=template&id=33d73c07&functional=true&", function () {
      api.rerender('33d73c07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/NextArrowIconNeutral.vue"
export default component.exports